<template>
  <div v-if="pageData">
    <div class="container mx-auto p-0" :class="isPackageAvailable ? 'bg-00953A' : 'bg-white'">
      <Hero
        :heroImageLink="pageData.banner_image
          ? imageLocation + pageData.banner_image.url
          : undefined"
        :title="pageData.intro_title"
        :text="pageData.intro_text"
        :color="pageData.service_color"
        fullWidth="true"
        breadcrumbCategoryTitle="Services"
        breadcrumbCategoryLink="/services"
        :breadcrumbTitle="pageData.intro_title"
        breadcrumbLink="/services/lawn-care-services"
      />

      <div class="container mx-auto p-0" id="premiumPackage">
        <PackageServiceCardList 
          :borderOverride="pageData.service_color" :hideUnavailable="false"  
          :hidePurchased="false" :packageBtn="false" size="large" 
          @isPackageAvailable="isPackageAvailable = $event"
        />
        <!-- <Curves background="fff" foreground="fff" location="bottomLeft" /> -->
      </div>

      <div class="container bg-white mx-auto p-0 pb-2 pt-16" v-if="featuredServices && featuredServices.length > 0 && hasVisibleFeaturedServices && !isPackageAvailable">
          <div class="grey-bend-left" style="width: 100%;margin-right: auto;">
            <div class="container">
              <ServicesCardList
                :headerText="pageData.featured_program_text"
                :services="featuredServices"
                :borderOverride="pageData.service_color"
                :hideUnavailable="true"
                :hidePurchased="true"
                size="large"
              />
            </div>
          </div>
          <Curves background="EEF1F4" foreground="fff" location="topLeft" />
        </div>
        <div class="container bg-white mx-auto p-0 pb-2 pt-16" v-if="featuredServices && featuredServices.length > 0 && !hasVisibleFeaturedServices">
          <div class="grey-bend-left">
            <div class="container">
              <ServicesCardList
                :headerText="pageData.featured_program_text"
                :services="featuredServices"
                :borderOverride="pageData.service_color"
                :hideUnavailable="false"
                :hidePurchased="false"
                size="large"
              />
            </div>
          </div>
          <Curves background="EEF1F4" foreground="fff" location="topLeft" />
      </div>
    
      <div class="container bg-white p-0 py-3 mx-auto"
        v-if="(addonServices && addonServices.length > 0) || (upsellServices && upsellServices.length > 0)">

        <div class="container mx-auto">
          <div class="text-center py-4">
            <h2 v-text="pageData.list_of_service_title"></h2>
            <p v-text="pageData.list_of_service_text"></p>
          </div>

<!-- 
          <ServicesCardList
            v-if="addonServices && addonServices.length > 0"
            :services="addonServices"
            :borderOverride="pageData.service_color"
            :hideUnavailable="true"
            :hidePurchased="true"
            size="small" layout="listview"
          /> -->

          <ServicesCardList
            v-if="upsellAddonServices && upsellAddonServices.length > 0"
            :services="upsellAddonServices"
            :borderOverride="pageData.service_color"
            :hideUnavailable="true"
            :hidePurchased="true"
            size="small" layout="listview"
          />

        </div>

      </div>

      <div class="container bg-white mx-auto p-0"
        v-if="relatedServices && relatedServices.length > 0"
      >
        <div class="">
          <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
            <div class="col-span-3 p-16"></div>
            <div class="w-100 md:col-span-2">
              <ServicesRelatedSidebar
                :services="relatedServices"
                :servicesTitle="pageData.related_services_text"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="container bg-white mx-auto p-0">
        <Curves background="EEF1F4" foreground="fff" location="bottomLeft" />
        <div class="grey-bend-left">
          <h2 v-text="pageData.section_1_title"></h2>
          <p v-html="pageData.section_1_text"></p>
          <img
            loading="lazy"
            :src="imageLocation + pageData.section_1_image.url"
            :alt="pageData.section_1_image.alt"
            class="mx-auto"
            v-if="pageData.section_1_image && pageData.section_1_image.url"
          />
          <div>
            <ul class="menu">
              <li
                v-for="link in pageData.list_of_lawn_problem_and_associated_link"
                :key="link.slug"
              >
                <NuxtLink :to="link.slug"> {{link.content}} </NuxtLink>
              </li>
            </ul>
          </div>
          <p>
            <NuxtLink :to="pageData.section_1_button_link" class="button">
              {{ pageData.section_1_button_text }}
            </NuxtLink>
          </p>
        </div>
        <Curves background="EEF1F4" foreground="fff" location="topLeft" />
      </div>

      <div class="container bg-white mx-auto pb-6">
        <div class="grid md:grid-cols-2 gap-8">
          <div>
            <img
              loading="lazy"
              :src="imageLocation + pageData.section_2_image.url"
              :alt="pageData.section_2_image.alt"
              class="rounded w-full"
              v-if="pageData.section_2_image && pageData.section_2_image.url"
            />
          </div>
          <div>
            <h3 class="h2" v-text="pageData.section_2_title"></h3>
            <p v-html="pageData.section_2_text"></p>
          </div>
          <div>
            <h3 class="h2" v-text="pageData.section_3_title"></h3>
            <p v-html="pageData.section_3_text"></p>
          </div>
          <div>
            <img
              loading="lazy"
              :src="imageLocation + pageData.section_3_image.url"
              :alt="pageData.section_3_image.alt"
              class="rounded w-full"
              v-if="pageData.section_3_image && pageData.section_3_image.url"
            />
          </div>
        </div>
      </div>

      <div class="container bg-white mx-auto pt-10 pb-10">
        <FaqList :categoryId="1" />
      </div>

    </div>
    <EmailCaptureModal />
  </div>
</template>

<script setup lang="ts">
import EmailCaptureModal from '~/components/EmailCapture/EmailCaptureModal.vue';
import PackageServiceCardList from '~/components/PremiumPackage/PackageServiceCardList.vue';
import FaqList from "~/components/Faqs/FaqList.vue";
import { useSeoHead, buildOfferCatalogSchema } from "~/composables/useSeo";

const { $sg, $userContext, $services, $config } = useNuxtApp();
const runtimeConfig = useRuntimeConfig();

const imageLocation = ref($config.public.sgCmsImage);
const featuredServices = ref<any>(undefined);
const addonServices = ref<any>(undefined);
const upsellServices = ref<any>(undefined);
const relatedServices = ref<any>(undefined);
const hasVisibleFeaturedServices = ref<boolean | undefined>(undefined);
const isPackageAvailable = ref(false);

// SSR-friendly data fetch for page content
const { data: pageData } = await useAsyncData(
  "lawn-care-services-page",
  () => $sg.getOctoberData("pages/landingpagelawncareservices")
);

const upsellAddonServices = computed(() => {
  return [...(addonServices.value || []), ...(upsellServices.value || [])];
});

// Compute frontend URL for structured data
const frontEndUrl = computed(() =>
  (runtimeConfig.public?.frontEndUrl || "https://www.spring-green.com").replace(/\/$/, "")
);

// Build OfferCatalog structured data for featured services when available.
// Emitted at top level with a stable @id so LocalBusiness nodes (franchise pages)
// can reference it via hasOfferCatalog without duplicating the catalog payload.
const offerCatalogSD = computed(() => {
  if (!featuredServices.value?.length) return null;
  return buildOfferCatalogSchema({
    id: `${frontEndUrl.value}/services/lawn-care-services/#offercatalog`,
    name: "Lawn Care Services",
    url: `${frontEndUrl.value}/services/lawn-care-services/`,
    description: pageData.value?.meta_description || "Professional lawn care services from Spring-Green",
    items: featuredServices.value.map((service: any) => ({
      name: service.ServiceName || service.name,
      url: `${frontEndUrl.value}/services/${service.ServiceSlug || service.slug}/`,
      serviceType: "Lawn Care",
    })),
  });
});

// Apply SEO head - runs on SSR and updates when offerCatalogSD changes
watchEffect(() => {
  useSeoHead({
    title: pageData.value?.seo_title || "Local Lawn Care Services & Weed Control | Spring-Green",
    description: pageData.value?.meta_description || 
      "For more than 45 years, Spring Green has been providing professional lawn care, pest control and tree care services. Visit www.spring-green.com to learn more about our dedication to quality.",
    openGraph: {
      title: pageData.value?.social_title || pageData.value?.seo_title || "Lawn Care Services | Spring-Green",
      description: pageData.value?.social_description || pageData.value?.meta_description,
      image: pageData.value?.banner_image?.url 
        ? `${$config.public.sgCmsImage}${pageData.value.banner_image.url}` 
        : undefined,
      type: "website",
    },
    breadcrumbs: [
      { name: "Home", url: `${frontEndUrl.value}/` },
      { name: "Services", url: `${frontEndUrl.value}/services/` },
      { name: pageData.value?.intro_title || "Lawn Care Services", url: `${frontEndUrl.value}/services/lawn-care-services/` },
    ],
    structuredData: offerCatalogSD.value,
  });
});

onMounted(async () => {
  // Client-side refresh for user-specific context
  await $userContext.metaRefresh({
    refresh: new Set(["ORDER_INFO", "SERVICE_INFO", "PACKAGE_INFO", "PAYMENT_INFO"]),
  });

  // Load services client-side (depends on user context/location)
  if (pageData.value) {
    const services = await $services.findPageServices(pageData.value);
    featuredServices.value = services.featuredServices;
    addonServices.value = services.addonServices;
    upsellServices.value = services.upsellServices;
    relatedServices.value = services.relatedServices;
    hasVisibleFeaturedServices.value = featuredServices.value?.some(
      (obj: any) => obj.showPurchase === true
    );
  }
});
</script>

<style scoped>
.bg-eef1f4 {
  background: #eef1f4;
}

.bg-00953A {
  background: #00953a;
}
</style>
